import { css as m, LitElement as g, nothing as p, html as c } from "lit";
import { property as o, customElement as v } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as u, f as y } from "./styles-scZ6dVz-.js";
import { b as f } from "./events-CkEPl0SM.js";
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, t = (i, a, l, s) => {
  for (var e = s > 1 ? void 0 : s ? x(a, l) : a, n = i.length - 1, d; n >= 0; n--)
    (d = i[n]) && (e = (s ? d(a, l, e) : d(e)) || e);
  return s && e && b(a, l, e), e;
};
let r = class extends g {
  constructor() {
    super(...arguments), this.cardTitle = "", this.description = "", this.actionText = "", this.primaryAction = !1, this.disabled = !1, this.highlighted = !1, this.layout = "vertical", this.size = "default";
  }
  handleAction() {
    this.disabled || f(this, "ark-action");
  }
  render() {
    const i = {
      card: !0,
      highlighted: this.highlighted
    }, a = {
      "action-button": !0,
      "focus-ring": !0,
      primary: this.primaryAction
    };
    return c`
      <div part="card" class=${h(i)}>
        <div class="header">
          <div part="icon" class="icon-wrapper">
            <slot name="icon"></slot>
          </div>
          <div part="content" class="content">
            ${this.cardTitle ? c`<h3 part="title" class="title">${this.cardTitle}</h3>` : p}
            ${this.description ? c`<p part="description" class="description">${this.description}</p>` : p}
          </div>
        </div>

        <div class="body">
          <slot></slot>
        </div>

        ${this.actionText ? c`
              <div class="footer">
                <button
                  part="action"
                  class=${h(a)}
                  ?disabled=${this.disabled}
                  @click=${this.handleAction}
                >
                  ${this.actionText}
                </button>
              </div>
            ` : p}
      </div>
    `;
  }
};
r.styles = [
  u,
  y,
  m`
      :host {
        display: block;
      }

      .card {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-4);
        padding: var(--r5-space-6);
        background-color: var(--r5-bg-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        height: 100%;
      }

      .card.highlighted {
        border-color: var(--r5-color-primary-200);
        background: linear-gradient(
          135deg,
          var(--r5-bg-surface) 0%,
          rgba(var(--r5-color-primary-500-rgb, 59, 130, 246), 0.05) 100%
        );
      }

      .header {
        display: flex;
        align-items: flex-start;
        gap: var(--r5-space-4);
      }

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border-radius: var(--r5-radius-lg);
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
        flex-shrink: 0;
      }

      .card.highlighted .icon-wrapper {
        background-color: rgba(var(--r5-color-primary-500-rgb, 59, 130, 246), 0.1);
        color: var(--r5-color-primary-600);
      }

      .icon-wrapper ::slotted(*) {
        width: 1.25rem;
        height: 1.25rem;
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1);
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-base);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        line-height: var(--r5-leading-tight);
        margin: 0;
      }

      .description {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-relaxed);
        margin: 0;
      }

      .body {
        flex: 1;
      }

      .footer {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        margin-top: auto;
      }

      .action-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: var(--r5-space-2);
        padding: var(--r5-space-2) var(--r5-space-4);
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-medium);
        font-family: inherit;
        color: var(--r5-color-primary-600);
        background-color: transparent;
        border: 1px solid var(--r5-color-primary-200);
        border-radius: var(--r5-radius-md);
        cursor: pointer;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .action-button:hover:not(:disabled) {
        background-color: var(--r5-color-primary-50);
        border-color: var(--r5-color-primary-300);
      }

      .action-button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .action-button.primary {
        color: white;
        background-color: var(--r5-color-primary-600);
        border-color: var(--r5-color-primary-600);
      }

      .action-button.primary:hover:not(:disabled) {
        background-color: var(--r5-color-primary-700);
        border-color: var(--r5-color-primary-700);
      }

      /* Horizontal layout */
      :host([layout='horizontal']) .card {
        flex-direction: row;
        align-items: center;
      }

      :host([layout='horizontal']) .header {
        flex: 1;
      }

      :host([layout='horizontal']) .footer {
        margin-top: 0;
      }

      /* Compact size */
      :host([size='compact']) .card {
        padding: var(--r5-space-4);
        gap: var(--r5-space-3);
      }

      :host([size='compact']) .icon-wrapper {
        width: 2rem;
        height: 2rem;
      }

      :host([size='compact']) .icon-wrapper ::slotted(*) {
        width: 1rem;
        height: 1rem;
      }

      :host([size='compact']) .title {
        font-size: var(--r5-text-sm);
      }

      :host([size='compact']) .description {
        font-size: var(--r5-text-xs);
      }
    `
];
t([
  o({ type: String })
], r.prototype, "cardTitle", 2);
t([
  o({ type: String })
], r.prototype, "description", 2);
t([
  o({ type: String })
], r.prototype, "actionText", 2);
t([
  o({ type: Boolean })
], r.prototype, "primaryAction", 2);
t([
  o({ type: Boolean })
], r.prototype, "disabled", 2);
t([
  o({ type: Boolean, reflect: !0 })
], r.prototype, "highlighted", 2);
t([
  o({ type: String, reflect: !0 })
], r.prototype, "layout", 2);
t([
  o({ type: String, reflect: !0 })
], r.prototype, "size", 2);
r = t([
  v("ark-action-card")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-action-card-CxtpOpQt.js.map
